module.exports = __webpack_public_path__ + "img/Bear15.4a943360.jpg";